import styled from 'styled-components'
import {
    svgStroke,
    belowPhone
} from 'utilities/styled'
import { BottomContainerInner } from 'utilities/panel'
import { PlainOnDark } from 'components/button'

export const Container = styled(BottomContainerInner)`
    grid-template-columns: repeat(2, minmax(min-content, auto));
    justify-content: space-between;
    column-gap: 40px;

    padding: 16px 40px;
    background-color: var(--huma-color-surface-constructive-bold);

    color: var(--huma-color-foreground-on-bold);

    ${belowPhone`
        display: flex;
        flex-direction: column;
        row-gap: 16px;

        padding: 16px;
    `}
`

export const CloseButton = styled(PlainOnDark)`
    svg {
        ${svgStroke()}
    }
`

export const BulkActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`